export function findAllUploadedFilesFromAllFileUploadQuestions(jsonForSave) {
  return jsonForSave
    .filter(questionField => questionField.attributeType === 'file')
    .flatMap(uploadFileQuestion => uploadFileQuestion.fileList)
    .filter(uploadFileQuestion => uploadFileQuestion !== undefined);
}
